import React from 'react';
import styled from 'styled-components';
import { Button } from '../design-system';
import { MdFormatIndentDecrease, MdFormatIndentIncrease } from 'react-icons/md';

const StyledButton = styled(Button)<{ isOpen?: boolean }>`
  padding: 0 8px;
  position: absolute;
  right: ${(p) => (p.isOpen ? 0 : '-12px')};
  transform: translateX(50%);
`;

interface SidebarToggleButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

const SidebarToggleButton = ({ onClick, isOpen }: SidebarToggleButtonProps) => (
  <StyledButton
    type="button"
    onClick={onClick}
    isOpen={isOpen}
    title={`${isOpen ? 'Close' : 'Open'} Sidebar`}
  >
    {isOpen ? (
      <MdFormatIndentDecrease size={22} />
    ) : (
      <MdFormatIndentIncrease size={22} />
    )}
  </StyledButton>
);

export default SidebarToggleButton;
